import React, { createContext, useCallback, useEffect, useReducer } from "react";
import { UserLoginResponseModel } from "../swagger-clients/s365-admin-panel-clients.service";
import { UserRole } from "./user-roles";
import authReducer, { initialState, LOGIN, LOGOUT } from "./auth-reducer";
import { authenticationService } from "../services/authentication-service";

export type AuthContextType = {
	isLoggedIn: boolean;
	isInitialized?: boolean;
	user?: UserLoginResponseModel | null | undefined;
	logout: () => void;
	isInRole: (roles: UserRole[]) => boolean;
	login: () => Promise<void>;
	onLoginSuccess: () => void;
};


export interface AuthProps {
	isLoggedIn: boolean;
	isInitialized?: boolean;
	user?: UserLoginResponseModel | null;
	token?: string | null;
}
const TOKEN_KEY = "s365_admin_panel_user";

const setSession = (user?: UserLoginResponseModel) => {
	if (user) {
		sessionStorage.setItem(TOKEN_KEY, JSON.stringify(user));
	} else {
		localStorage.removeItem(TOKEN_KEY);

	}
};

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactElement }) => {
	const [state, dispatch] = useReducer(authReducer, initialState);

	// useEffect(() => {
	// 	const init = async () => {
	// 		try {
	// 			const sessionUserJson = window.localStorage.getItem(TOKEN_KEY);

	// 			let user: UserLoginResponseModel | undefined;
	// 			if (!!sessionUserJson) {
	// 				user = JSON.parse(sessionUserJson);
	// 			}
	// 			else {
	// 				user = await authenticationService.GetCurrentUser();
	// 			}
	// 			dispatch({
	// 				type: LOGIN,
	// 				payload: {
	// 					isLoggedIn: true,
	// 					user
	// 				}
	// 			});

	// 		} catch (err) {
	// 			console.error(err);
	// 			dispatch({
	// 				type: LOGOUT
	// 			});
	// 		}
	// 	};

	// 	init();
	// }, []);

	const isInRole = useCallback((roles: (UserRole | string)[]) => {
		const { user } = state;
		if (!user || !user.roles)
			return false;
		const existingRoles = user.roles.filter(x => roles.indexOf(x) > -1);
		return !!existingRoles && existingRoles.length > 0;
	}, [state?.user]);

	const login = async () => {
		authenticationService.Login();
	};

	const onLoginSuccess = async () => {
		try {
			const { user } = state;
			if (!user) {
				const userResp = await authenticationService.GetCurrentUser();
				//setSession(userResp);
				if (userResp != null)
					dispatch({
						type: LOGIN,
						payload: {
							isLoggedIn: true,
							user: userResp
						}
					});
			}

		} catch (error) {
			console.log("An error occurred while calling onLoginSuccess.");
		}
	}


	const logout = () => {
		dispatch({ type: LOGOUT });
	};


	return <AuthContext.Provider value={{ ...state, login, logout, onLoginSuccess, isInRole }}>{children}</AuthContext.Provider>;
};

export default AuthContext;